export default "__VITE_ASSET__10d24e7f__"